// This file is auto-generated by set-version.js
export const APP_VERSION = '1.0.28';
